<div class="quick-quote-container" dclClickOutside (clickOutside)="closeWrapper($event)">
    <dcl-quick-quote-bar
        [isOpen]="isOpen"
        [isMobile]="isMobile"
        [filterOptions]="filterData"
        (onApplyFilters)="onApplyFilters()"
        (onFilterSelected)="openFilter($event)">
    </dcl-quick-quote-bar>
    <div class="mobile" *ngIf="isModalOpen">
        <dcl-quick-quote-modal
            [filtersData]="filterData"
            [filterDataSubGroup]="filterDataSubGroup"
            (onApplyFilters)="onApplyFilters()"
            (onClearFilters)="onClearFilters()"
            (onCloseModal)="onCloseModal($event)"
            [open]="isModalOpen">
        </dcl-quick-quote-modal>
    </div>
    <div class="desktop">
        <dcl-quick-quote-filter-wrapper
            *ngIf="isOpen"
            [filterData]="filterData[filterSelectedIndex]"
            [filterDataSubGroup]="filterDataSubGroup"
            [showClearBtn]="constants.filters['travel-party'].id !== filterData[filterSelectedIndex]?.type">
        </dcl-quick-quote-filter-wrapper>
    </div>
</div>
